import React from 'react';
import { FaTimes } from 'react-icons/fa';

const PaymentTermsViewModal = ({ open, onClose, term }) => {
  if (!open || !term) return null;

  const fields=[
    {label:'Code',value:term.Code},
    {label:'Due Date',value:term.DueDate||'-'},
    {label:'Description',value:term.Description}
  ];

  return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-2">
    <div className="bg-[#E5E1DA] rounded-2xl shadow-2xl w-full max-w-md p-4 sm:p-8 relative max-h-[90vh] overflow-y-auto">
      
      {/* Close button */}
      <button
        className="absolute top-3 right-3 text-[#2b6777] hover:text-[#52ab98]"
        onClick={onClose}
      >
        <FaTimes size={18} />
      </button>

      {/* Title */}
      <h2 className="text-lg sm:text-2xl font-bold text-[#2b6777] mb-4 sm:mb-6 text-center">
        Payment Term Details
      </h2>

      {/* Fields */}
      <div className="bg-white p-4 sm:p-6 rounded-xl space-y-3 sm:space-y-4">
        {fields.map((f, i) => (
          <div key={i}>
            <span className="block text-xs sm:text-sm text-gray-600">{f.label}</span>
            <span className="block text-sm sm:text-base text-gray-900">{f.value}</span>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="mt-4 sm:mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="px-3 sm:px-4 py-2 rounded bg-[#52ab98] text-white text-sm sm:text-base"
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

};

export default PaymentTermsViewModal;
